import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import AffiliateList from './affiliate.list';
import AffiliateView from './affiliate.view';
import Capacity from 'components/Capacity';

/**
 *   Create index file for affiliate
 */

export default function AffiliateIndex() {
  let {
    slug = 'list'
  } = useParams();
  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = <Capacity current_user_can={['manage_affiliates', 'view_affiliates']} onFail={<Theme404 />}>
          <AffiliateList />
        </Capacity>;
      break;
    case 'view':
      ActualPage = <Capacity current_user_can={['manage_affiliates', 'view_affiliates']} onFail={<Theme404 />}>
          <AffiliateView />
        </Capacity>;
      break;
    default:
      ActualPage = <Theme404 />;
      break;
  }
  return ActualPage;
}